import React, { useState, useEffect } from "react";
import TechniqueCard from "./TechniqueCard";
import { useUser } from "../../Home/UserContext";
import useScrollToTop from "../../../hooks/useScollToTop";
import ScrollIndicator from "./../../Home/ScrollIndicator";
import { getTechniquesUV2 } from "../../../services/techniquesServices";
import { useNavigate } from "react-router-dom";

const TechniquesUV = () => {
  useScrollToTop();
  const [techniques, setTechniques] = useState([]);
  const [filteredTechniques, setFilteredTechniques] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCeinture, setSelectedCeinture] = useState("Toutes les ceintures");
  const [selectedFamille, setSelectedFamille] = useState("Toutes les familles");
  const [selectedFiche, setSelectedFiche] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Récupération initiale des techniques
    const fetchTechniques = async () => {
      const fetchedTechniques = await getTechniquesUV2();
      setTechniques(fetchedTechniques);
    };

    fetchTechniques();
  }, []);

  const handleCeintureChange = (e) => setSelectedCeinture(e.target.value);
  const handleFamilleChange = (e) => setSelectedFamille(e.target.value);
  const handleFicheChange = (e) => {
    setSelectedFiche(e.target.value);
    const ficheFiltered = techniques.filter((technique) =>
      technique.uv2?.includes(e.target.value)
    );
    setFilteredTechniques(ficheFiltered);
  };
  const handleSearchChange = (e) => setSearchTerm(e.target.value.toLowerCase());

  const handleTirageAuSort = () => {
    const fiches = [
      "1A", "1B", "1C", "1D", "1E", "1F", "1G", "1H", "1I", "1J", "1K", "1L", "1M", "1N", "1O", "1P", "1Q",
    ];
    const randomFiche = fiches[Math.floor(Math.random() * fiches.length)];
    setSelectedFiche(randomFiche);

    const ficheFiltered = techniques.filter((technique) =>
      technique.uv2?.includes(randomFiche)
    );
    setFilteredTechniques(ficheFiltered);
  };

  const applyFilters = () => {
    const ficheFiltered = techniques.filter(
      (technique) =>
        (selectedFiche ? technique.uv2?.includes(selectedFiche) : true) &&
        (selectedCeinture === "Toutes les ceintures" || technique.ceinture === selectedCeinture) &&
        (selectedFamille === "Toutes les familles" || technique.famille === selectedFamille) &&
        technique.nom.toLowerCase().includes(searchTerm)
    );
    setFilteredTechniques(ficheFiltered);
  };

  useEffect(() => {
    applyFilters();
  }, [searchTerm, selectedCeinture, selectedFamille, selectedFiche]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="w-full pt-[100px] font-satoshi">
      <ScrollIndicator />
      <div
        className="w-full h-72 bg-cover bg-center"
        style={{ backgroundImage: `url('/img/diapo/slider_judo_06.webp')` }}
      ></div>
      <div className="bg-black bg-opacity-50 text-white p-4 max-w-[1280px] mx-auto">
        <p className="text-sm font-satoshi">
          <span
            onClick={() => handleNavigation("/")}
            className="text-white hover:underline cursor-pointer"
          >
            Accueil
          </span>{" "}
          &gt; Techniques &gt; Révisions pour UV2
        </p>
        <h1 className="text-2xl font-bold font-satoshi">Révisions pour UV2</h1>
      </div>

      <div className="overflow-x-auto max-w-[1280px] mx-auto w-full p-4">
        <div className="mb-4 text-xl">
          <button
            className="btn bg-blueprimary hover:bg-blueprimarylight w-full btn-primary"
            onClick={handleTirageAuSort}
          >
            <span className="text-xl">Tirage au sort d'une fiche</span>
          </button>
        </div>
        {selectedFiche && (
          <p className="text-lg font-bold text-center mb-4">
            Fiche sélectionnée : {selectedFiche}
          </p>
        )}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <select
              className="select select-bordered w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm dark:bg-slate-200 dark:text-black"
              value={selectedCeinture}
              onChange={handleCeintureChange}
            >
              <option value="Toutes les ceintures">Toutes les ceintures</option>
              <option value="Jaune">Jaune</option>
              <option value="Orange">Orange</option>
              <option value="Verte">Verte</option>
              <option value="Bleue">Bleue</option>
              <option value="Marron">Marron</option>
              <option value="Noire">Noire</option>
            </select>
          </div>

          <div>
            <select
              className="select select-bordered w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm dark:bg-slate-200 dark:text-black"
              value={selectedFamille}
              onChange={handleFamilleChange}
            >
              <option value="Toutes les familles">Toutes les familles</option>
              <option value="Jambe">Jambe</option>
              <option value="Hanche">Hanche</option>
              <option value="Epaule">Epaule</option>
              <option value="Bras">Bras</option>
              <option value="Sutemi Waza">Sutemi Waza</option>
              <option value="Immobilisation">Immobilisation</option>
              <option value="Shime Waza">Shime Waza</option>
              <option value="Kansetsu-Waza">Kansetsu-Waza</option>
              <option value="Self Défense">Self Défense</option>
            </select>
          </div>

          <div>
            <select
              className="select select-bordered w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm dark:bg-slate-200 dark:text-black"
              value={selectedFiche}
              onChange={handleFicheChange}
            >
              <option value="">Choisir une fiche manuellement</option>
              {[
                "1A",
                "1B",
                "1C",
                "1D",
                "1E",
                "1F",
                "1G",
                "1H",
                "1I",
                "1J",
                "1K",
                "1L",
                "1M",
                "1N",
                "1O",
                "1P",
                "1Q",
              ].map((fiche) => (
                <option key={fiche} value={fiche}>
                  {fiche}
                </option>
              ))}
            </select>
          </div>

          <div>
            <input
              type="text"
              className="input input-bordered w-full"
              placeholder="Recherche par nom..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>

      <div className="overflow-x-auto mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-[1280px] p-4">
        {filteredTechniques.map((technique) => (
          <TechniqueCard key={technique.id} technique={technique} />
        ))}
      </div>
    </div>
  );
};

export default TechniquesUV;
